<template>
    <VenueSection
        v-bind="filters"
        :color-theme="colorTheme"
    >
        <template #title>
            {{ title }}
        </template>
    </VenueSection>
</template>

<script setup lang="ts">
import type { FlexibleVenueBlockFragment } from '~/types/craft-schema';

const props = defineProps<FlexibleVenueBlockFragment>();

const filters = useExtractFiltersFromCraftBundle(props.venueBundle?.[0]);
</script>
